import moment from 'moment-timezone';
import { pathToRegexp } from 'path-to-regexp';

export const toISOString = (date: any, time: any): string | undefined => {
  const dateTime = toDateTime(date, time);
  if (dateTime) {
    const finalDateTime = moment(dateTime).toISOString();
    return finalDateTime;
  }

  return undefined;
};

export const toDateTime = (date: any, time: any): string | undefined => {
  if (date && time) {
    const dateTime = `${moment(date).format('YYYY-MM-DD')} ${moment(time).format('HH:mm:ss')}`;

    return dateTime;
  }

  return undefined;
};

export const toSecondByHour = (hour?: number): number | undefined => {
  if (!hour) return undefined;
  return hour * 60 * 60;
};

export const toSecondByDay = (day?: number): number | undefined => {
  if (!day) return undefined;
  return day * 24 * 60 * 60;
};

export const toHourBySecond = (second?: number): number | undefined => {
  if (!second) return undefined;
  return Number((second / (60 * 60)).toFixed(2));
};

export const toDayBySecond = (second?: number): number | undefined => {
  if (!second) return undefined;
  return Number((second / (24 * 60 * 60)).toFixed(2));
};

export const onValidator = (values: any) => ({
  validator(rule: any, value: any) {
    if (value && value.trim() !== '' && !values.some((x: any) => x.value === value)) {
      return Promise.reject(new Error('Invalid select value!'));
    }
    return Promise.resolve();
  },
});

export const findItemChildren = (pages: any[], path: string): any => {
  for (const page of pages) {
    if (page.route && pathToRegexp(page.route).exec(path)) {
      return page;
    }
    if (page.group) {
      const data = findItemChildren(page.group, path);
      if (data) {
        return data;
      }
    }
    if (page.children) {
      const data = findItemChildren(page.children, path);
      if (data) {
        return data;
      }
    }
  }

  return null;
};
